// extracted by mini-css-extract-plugin
export default {"landing-bg":"LoadingBg_landing-bg__eS0u-","logo-container":"LoadingBg_logo-container__c9-Vs","big-logo":"LoadingBg_big-logo__rVOPe","small-logo":"LoadingBg_small-logo__jx2gv"};